/**
 * Lodestar — Footer with legal links + brand line.
 *
 * Site-wide footer designed to be embedded at the bottom of any
 * full-page route. Ships the three Tier-1 legal anchors (Privacy,
 * Terms, Contact) plus a subtle copyright line. Royal palette,
 * matches the rest of the design language.
 *
 * Used by: Landing, Today, Horoscope, Compatibility, Synastry, etc.
 * Account / dashboard pages render inside AppShell which has its own
 * chrome, so the footer is opt-in there.
 */
import { Link } from "react-router-dom";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="relative z-10 border-t border-lodestar-gold-soft/15 mt-20">
            <div className="max-w-screen-lg mx-auto px-6 py-10">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
                    <div>
                        <div className="font-display text-lg text-lodestar-white-pure">Lodestar</div>
                        <div className="text-[12px] text-lodestar-white-mist/55 mt-1 leading-relaxed max-w-md">
                            Reflective guidance only &middot; not medical, legal, or financial advice.
                        </div>
                        <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-[11.5px] text-lodestar-white-mist/60">
                            <a
                                href="mailto:support@lodestarastrology.com"
                                data-testid="footer-mailto-support"
                                className="hover:text-lodestar-gold-bright"
                            >
                                support@lodestarastrology.com
                            </a>
                            <a
                                href="mailto:consult@lodestarastrology.com"
                                data-testid="footer-mailto-consult"
                                className="hover:text-lodestar-gold-bright"
                            >
                                consult@lodestarastrology.com
                            </a>
                        </div>
                    </div>
                    <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px] text-lodestar-white-mist/80">
                        <Link to="/today" className="hover:text-lodestar-gold-bright">Today</Link>
                        <Link to="/synastry" className="hover:text-lodestar-gold-bright">Synastry</Link>
                        <Link to="/pricing" className="hover:text-lodestar-gold-bright">Pricing</Link>
                        <Link to="/consult" data-testid="footer-link-consult" className="hover:text-lodestar-gold-bright">Consult 1-on-1</Link>
                        <Link to="/methodology" data-testid="footer-link-methodology" className="hover:text-lodestar-gold-bright">Methodology</Link>
                        <Link to="/glossary" data-testid="footer-link-glossary" className="hover:text-lodestar-gold-bright">Glossary</Link>
                        <Link to="/sample" data-testid="footer-link-sample" className="hover:text-lodestar-gold-bright">Sample</Link>
                        <Link to="/contact" data-testid="footer-link-contact" className="hover:text-lodestar-gold-bright">Contact</Link>
                        <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-lodestar-gold-bright">Privacy</Link>
                        <Link to="/terms" data-testid="footer-link-terms" className="hover:text-lodestar-gold-bright">Terms</Link>
                        <Link to="/disclaimer" data-testid="footer-link-disclaimer" className="hover:text-lodestar-gold-bright">Disclaimer</Link>
                        <Link to="/refund" data-testid="footer-link-refund" className="hover:text-lodestar-gold-bright">Refund</Link>
                    </nav>
                </div>
                <div className="mt-8 pt-6 border-t border-lodestar-gold-soft/10 flex flex-wrap items-center justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-lodestar-white-mist/45">
                    <div>© {year} Lodestar Astrology</div>
                    <div>A royal observatory for your life</div>
                </div>
            </div>
        </footer>
    );
}
